import { Currency } from "@redotech/money/currencies";
import { moneyFormat } from "@redotech/money/util";
import * as React from "react";

export const FlexibleCheckoutButtons = ({
  onClickCoverage,
  onClickNoCoverage,
  isCoverage,
  dataTarget,
  coveragePrice,
  cartTotal,
  cartTotalPreDiscount,
  html,
  customCss,
  currency,
}: {
  onClickCoverage: (event: React.MouseEvent) => void;
  onClickNoCoverage: (event: React.MouseEvent) => void;
  isCoverage: boolean;
  dataTarget?: string;
  coveragePrice: number;
  cartTotal: number;
  cartTotalPreDiscount: number;
  html: string;
  customCss?: string;
  currency: Currency;
}) => {
  // replace html here then place.

  html = html.replaceAll(
    "%price%",
    moneyFormat({ amount: coveragePrice, currency }),
  );
  html = html.replaceAll(
    "%cartTotal%",
    moneyFormat({ amount: cartTotal, currency }),
  );
  html = html.replaceAll(
    "%combinedPrice%",
    moneyFormat({ amount: coveragePrice + cartTotal, currency }),
  );
  html = html.replaceAll(
    "%cartTotalPreDiscount%",
    moneyFormat({ amount: cartTotalPreDiscount, currency }),
  );
  html = html.replaceAll(
    "%combinedPricePreDiscount%",
    moneyFormat({ amount: cartTotalPreDiscount + coveragePrice, currency }),
  );
  return (
    <>
      {customCss ? <style>{customCss}</style> : null}
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        data-target={`${dataTarget || (isCoverage ? "coverage-button" : "non-coverage-button")}`}
        onClick={isCoverage ? onClickCoverage : onClickNoCoverage}
      />
    </>
  );
};
